<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="4" class="order-xl-2">
          <b-card class="">
            <b-card-header
              v-if="scheme && scheme.scheme_data"
              class="text-left "
            >
              <h4 v-if="scheme.scheme_data.from_date">
                From:
                <b>{{ from_date }}</b>
              </h4>
              <h4 v-if="scheme.scheme_data.to_date">
                To:
                <b>{{ to_date }}</b>
              </h4>
              <h4 v-if="scheme.scheme_data.accident_date">
                Dated:
                <b>{{ accident_date }}</b>
              </h4>
              <h4 v-if="scheme.scheme_data.incident_date">
                Dated:
                <b>{{ incident_date }}</b>
              </h4>
              <h4 v-if="scheme.scheme_data.administrative_date">
                Dated:
                <b>{{ administrative_date }}</b>
              </h4>
              <h4 v-if="scheme.scheme_data.created_date">
                Submitted On:
                <b>{{ created_date }}</b>
              </h4>
            </b-card-header>

            <b-card-body
              class="pt-0"
              v-if="
                scheme &&
                  scheme.scheme_data &&
                  scheme.scheme_data.attachments &&
                  scheme.scheme_data.attachments.length
              "
            >
              <h5 class="p-1">Attachments</h5>
              <b-row
                v-for="attachment in scheme.scheme_data.attachments"
                :key="attachment.name"
                class="mb-1"
              >
                <!-- <b-card class="p-0 w-100"> -->
                <div class="p-1">
                  <a :href="attachment.file_url" target="_blank" download>
                    <h4>{{ attachment.name }}</h4>
                  </a>
                  <hr class="m-1 w-100" />
                </div>
                <!-- </b-card> -->
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col xl="8" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Scheme Details</h3>
              </b-col>
            </b-row>

            <div>
              <h6 class="heading-small text-muted mb-4">
                <h2>
                  <b>{{ scheme.scheme_name }}</b>
                </h2>
              </h6>

              <div class="pl-lg-4" v-if="scheme && scheme.scheme_data">
                <h3>
                  Submitted By:
                  <router-link
                    v-if="$route.query.userId"
                    :to="{
                      name: 'Member Page',
                      params: { id: $route.query.userId }
                    }"
                  >
                    <b>{{ scheme.created_by }}</b>
                  </router-link>
                  <b v-else>{{ scheme.created_by }}</b>
                </h3>
                <h4 v-if="scheme.scheme_data.incident_type">
                  Type:
                  <b>{{ scheme.scheme_data.incident_type }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.accident_type">
                  Type:
                  <b>{{ scheme.scheme_data.accident_type }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.incident_location">
                  Location:
                  <b>{{ scheme.scheme_data.incident_location }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.accident_location">
                  Location:
                  <b>{{ scheme.scheme_data.accident_location }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.administrative_location">
                  Location:
                  <b>{{ scheme.scheme_data.administrative_location }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.case_details">
                  Case Details:
                  <b>{{ scheme.scheme_data.case_details }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.previous_case_details">
                  Previous Case Details:
                  <b>{{ scheme.scheme_data.previous_case_details }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.mobile">
                  Phone:
                  <b>{{ scheme.scheme_data.mobile }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.email">
                  Email:
                  <b>{{ scheme.scheme_data.email }}</b>
                </h4>
                <h4 v-if="scheme.scheme_data.address">
                  Address:
                  <b>{{ scheme.scheme_data.address }}</b>
                </h4>
                <div
                  v-if="
                    scheme.scheme_data.nominees &&
                      scheme.scheme_data.nominees.length
                  "
                >
                  <h3>
                    Nominees:
                  </h3>
                  <b-col
                    lg="6"
                    md="6"
                    sm="12"
                    v-for="nominee in scheme.scheme_data.nominees"
                    :key="nominee._id"
                  >
                    <card>
                      <div>
                        <b-row>
                          <b-col cols="10">
                            <h4>
                              {{ nominee.first_name }} {{ nominee.last_name }}
                            </h4>
                            <h5 class="text-capitalize">
                              {{ nominee.relation }}
                            </h5>
                          </b-col>
                          <b-col cols="2">
                            <h2>{{ nominee.share }}%</h2>
                          </b-col>
                        </b-row>
                      </div>

                      <hr class="my-1" />
                      <h5>
                                  <div
                      class="icon icon-shape text-dark p-0"
                    >
                      <i class="ni ni-shop"></i>
                    </div>
                        {{ nominee.address }}
                      </h5>
                      <h5>
                          <div
                      class="icon icon-shape text-dark "
                    >
                      <i class="ni ni-mobile-button"></i>
                    </div>
                        {{ nominee.mobile }}
                      </h5>
                    </card>
                  </b-col>
                </div>
              </div>
              <hr class="my-4" />

              <!-- Address -->
              <!-- <h6 class="heading-small text-muted mb-4">Contact information</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col md="12">
                    <base-input
                      type="text"
                      label="Address"
                      placeholder="Home Address"
                      :value="scheme.address"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="City"
                      placeholder="City"
                      :value="scheme.city"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Country"
                      placeholder="Country"
                      :value="scheme.country"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      label="Postal Code"
                      placeholder="ZIP Code"
                      :value="scheme.postalCode"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Phone"
                      placeholder="Phone"
                      :value="scheme.mobile"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div> -->

              <!-- <hr class="my-4" />

      <h6 class="heading-small text-muted mb-4">About me</h6>
      <div class="pl-lg-4">
        <b-form-group
          label="About Me"
          label-class="form-control-label"
          class="mb-0"
          label-for="about-form-textaria"
        >
          <b-form-textarea
            rows="4"
            value="A beautiful premium dashboard for BootstrapVue."
            id="about-form-textaria"
            placeholder="A few words about you ..."
          ></b-form-textarea>
        </b-form-group>
      </div> -->
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
// import ProgressTrackList from "@/views/Dashboard/ProgressTrackList";
import swal from "sweetalert2";
import { getAge, capitalizeAll } from "../../util/filters";
import { mapActions, mapGetters } from "vuex";
import { API } from "../../services/api.service";
import moment from "moment";
import Card from "../../components/Cards/Card.vue";
export default {
  components: { Card },
  //   components: {
  //     EditProfileForm,
  //     UserCard,
  //     // ProgressTrackList
  //   },

  data() {
    return {
      scheme: {}
    };
  },
  filters: { getAge, capitalizeAll },
  computed: {
    dateOfBirth: {
      get() {
        return this.scheme.dob
          ? moment(this.scheme.dob).format("yyyy-MM-DD")
          : "";
      },
      // setter
      set(newValue) {
        this.scheme.dob = new Date(newValue);
      }
    },
    from_date: {
      get() {
        return this.scheme.scheme_data && this.scheme.scheme_data.from_date
          ? moment(this.scheme.scheme_data.from_date).format("DD MMM YYYY")
          : "";
      }
    },
    to_date: {
      get() {
        return this.scheme.scheme_data && this.scheme.scheme_data.to_date
          ? moment(this.scheme.scheme_data.to_date).format("DD MMM YYYY")
          : "";
      }
    },
    accident_date: {
      get() {
        return this.scheme.scheme_data && this.scheme.scheme_data.accident_date
          ? moment(this.scheme.scheme_data.accident_date).format("DD MMM YYYY")
          : "";
      }
    },
    incident_date: {
      get() {
        return this.scheme.scheme_data && this.scheme.scheme_data.incident_date
          ? moment(this.scheme.scheme_data.incident_date).format("DD MMM YYYY")
          : "";
      }
    },
    administrative_date: {
      get() {
        return this.scheme.scheme_data &&
          this.scheme.scheme_data.administrative_date
          ? moment(this.scheme.scheme_data.administrative_date).format(
              "DD MMM YYYY"
            )
          : "";
      }
    },
    created_date: {
      get() {
        return this.scheme.scheme_data && this.scheme.scheme_data.created_date
          ? moment(this.scheme.scheme_data.created_date).format("DD MMM YYYY")
          : "";
      }
    }
  },
  created() {
    this.getScheme();
  },
  methods: {
    getScheme() {
      API.GET_SCHEME(this.$route.params.id).then((res, err) => {
        try {
          if (res) {
            if (res.data.ok) {
              if (res.data.result) {
                this.scheme = res.data.result;
              }
            }
          }
        } catch (e) {
          swal.fire({
            title: `${e}`,
            buttonsStyling: false,
            type: "warning",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        }
      });
    },
    changeApproval(key) {
      var obj = {};
      if (key === "isApproved" && !this.scheme.isApproved) {
        obj["isApproved"] = true;
        obj["isActive"] = true;
      } else obj[key] = !this.scheme[key];
      this.updateUser(obj);
    },
    updateUser(dataObj) {
      API.UPDATE_USER(this.$route.params.id, dataObj)
        .then(res => {
          if (res.data.ok) {
            swal.fire({
              title: `User details updated!`,
              buttonsStyling: false,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill"
            });
            this.getScheme();
          }
        })
        .catch(e => {
          var a = this.schemes;
          a.findIndex(x => x.schemeId === uid);

          swal.fire({
            title: `${e.response.data.message}` || "Something went Wrong!",
            buttonsStyling: false,
            type: "error",
            confirmButtonClass: "btn btn-danger btn-fill"
          });
        });
    },
    ...mapActions("scheme", ["setUserInfo", "setJWTToken"])
  }
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
